import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LayoutAdminHeader from '../components/LayoutAdminHeader';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ChangePassword = () => {
  const [form, setForm] = useState({
    gstNumber: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const validateLocal = () => {
    if (!form.gstNumber) {
      alert('Please enter GST Number.');
      return false;
    }
    if (!form.newPassword || !form.confirmPassword) {
      alert('Please enter password and confirm password.');
      return false;
    }
    if (form.newPassword !== form.confirmPassword) {
      alert('Passwords do not match.');
      return false;
    }
    if (form.newPassword.length < 7) {
      alert('Password should be at least 7 characters.');
      return false;
    }
    // Add more complexity checks if you want (regex)...
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateLocal()) return;

    setLoading(true);
    try {

      const res = await axios.put(
        `${BASE_URL}/Registration/ResetPasswordByGst`,
        {
          gstNumber: form.gstNumber,
          password: form.newPassword
        }
      );

      if (res.data && res.data.success) {
        alert('Password updated successfully.');
        setForm({ gstNumber: '', newPassword: '', confirmPassword: '' });
        navigate('/Login'); // redirect to Login (as in your ForgetPassword)
      } else {
        // server can return success:false or different shape
        alert(res.data?.message || 'Failed to update password. Please try again.');
      }
    } catch (err) {
      console.error('Change password error:', err);
      const message = err.response?.data?.message || err.response?.data || err.message || 'Server error';
      alert(`Password update failed: ${message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
     <LayoutAdminHeader />
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      backgroundImage: 'url("Images/login.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <Paper sx={{ p: 5, width: '100%', maxWidth: 520, borderRadius: 3, backgroundColor: 'rgba(255,255,255,0.92)' }} elevation={4}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 3, color: '#003366' }}>
          Change Password
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="User Name"
            name="gstNumber"
            value={form.gstNumber}
            onChange={handleChange}
            required
            fullWidth
            sx={{ mb: 2 }}
          />

          <TextField
            label="New Password"
            name="newPassword"
            type={showPassword ? 'text' : 'password'}
            value={form.newPassword}
            onChange={handleChange}
            required
            fullWidth
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(p => !p)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Confirm Password"
            name="confirmPassword"
            type={showConfirm ? 'text' : 'password'}
            value={form.confirmPassword}
            onChange={handleChange}
            required
            fullWidth
            sx={{ mb: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirm(p => !p)} edge="end">
                    {showConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        </form>
      </Paper>
    </Box>
        </>
  );
};

export default ChangePassword;
